'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import { HighlightIcon } from '@/assets/icons';
import type { HomeHighlight } from '@/constants/homeMarketing';
import { H3, P, Span, surfaceCardInteractive } from '@/components/ui';

export type HomeHighlightsSectionProps = {
  title: string;
  subtitle?: string;
  items: readonly HomeHighlight[];
  sectionId?: string;
  className?: string;
};

/** Value proposition row — three glass cards with icon, title, and body copy. */
const HomeHighlightsSection: React.FC<HomeHighlightsSectionProps> = ({
  title,
  subtitle,
  items,
  sectionId,
  className,
}) => (
  <section
    id={sectionId}
    className={clsx('container-section', className)}
    aria-labelledby="home-highlights-heading"
  >
    <div className="page-heading-wrap" id="home-highlights-heading">
      <Heading2
        title={title}
        subtitle={subtitle}
        titleClassName="text-prose"
        subtitleClassName="mt-3 text-prose-muted"
      />
    </div>
    <div className="page-content-grid page-grid-3">
      {items.map((item, i) => (
        <article
          key={i}
          className={surfaceCardInteractive('text-start')}
        >
          <Span className="page-highlight-icon" aria-hidden>
            <HighlightIcon name={item.icon} />
          </Span>
          <H3 className="page-card-title mt-3">{item.title}</H3>
          <P className="m-0 mt-2 text-sm leading-relaxed text-prose-muted">{item.text}</P>
        </article>
      ))}
    </div>
  </section>
);

export default HomeHighlightsSection;
